import { render } from "./professores-single.vue?vue&type=template&id=1c4cd706&scoped=true"
import script from "./professores-single.vue?vue&type=script&lang=js"
export * from "./professores-single.vue?vue&type=script&lang=js"

import "./professores-single.vue?vue&type=style&index=0&id=1c4cd706&lang=scss&scoped=true"
import "./professores-single.vue?vue&type=style&index=1&id=1c4cd706&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4cd706"]])

export default __exports__